import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import NavigationLink from './NavigationLink';
import { addOverlay, removeOverlay } from '../../Actions/Overlay.action';
import { useDispatch } from 'react-redux';
import(`./styles/${window.__litium.themeName}.scss`);

const Navigation = ({ blockElements }) => {
  const dispatch = useDispatch();
  const contentLinks = useSelector((state) => state.navigation.contentLinks);

  const [activeMegaMenuLink, setActiveMegaMenuLink] = useState();
  const [megaMenuTimer, setMegaMenuTimer] = useState();

  const onLinkHover = (link) => {
    clearTimeout(megaMenuTimer);
    setMegaMenuTimer(
      setTimeout(() => {
        setActiveMegaMenuLink(link);
        setMegaMenuTimer(null);
      }, 100)
    );
  };

  const onMouseLeaveLink = () => {
    clearTimeout(megaMenuTimer);
    setMegaMenuTimer(
      setTimeout(() => {
        setActiveMegaMenuLink(null);
        setMegaMenuTimer(null);
      }, 100)
    );
  };

  const onMegaMenuClose = () => setActiveMegaMenuLink(null);

  useEffect(() => {
    if (activeMegaMenuLink != null && activeMegaMenuLink.links?.length > 0) {
      dispatch(addOverlay('MegaMenu', onMegaMenuClose));
    } else {
      dispatch(removeOverlay('MegaMenu'));
    }
  }, [activeMegaMenuLink]);

  return contentLinks?.length > 0 ? (
    <div className="navbar__menu">
      <ul className="navbar__menu-links">
        {contentLinks.map((link) => (
          <NavigationLink
            key={link.url + link.name + 'NavigationLink'}
            link={link}
            isActive={link.links?.length > 0 && activeMegaMenuLink == link}
            onLinkHover={() => onLinkHover(link)}
            onMouseLeaveLink={onMouseLeaveLink}
            blocks={blockElements.filter(
              (b) =>
                link.blockSystemIds.indexOf(b.dataset['litiumBlockId']) != -1
            )}
          />
        ))}
      </ul>
    </div>
  ) : null;
};

export default Navigation;
